<mat-chip-list class="search-results__tags-list">
  <mat-chip xpoTag *ngFor="let tag of params.node.data.metadata">
    <div class="search-results__tag">{{ tag.tag }}: {{ tag.value }}</div>
  </mat-chip>
</mat-chip-list>
